import { render, staticRenderFns } from "./SupportTheSite.vue?vue&type=template&id=44818a9a&"
import script from "./SupportTheSite.vue?vue&type=script&lang=js&"
export * from "./SupportTheSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports